// extracted by mini-css-extract-plugin
export default {"todosActionsContainer":"TodoActions_todosActionsContainer__1Vpxq"};